/*
 * Exports
 */
export { default } from './components/CheckboxFilter.component';



// WEBPACK FOOTER //
// ./app/components/shared/Facets/CheckboxFilter/index.js